import axios from 'axios';
import { API_URL } from '../../../utils/constants';
import { toast } from "react-toastify";

export const getAzureApi = async (param) => {
  try {
    param.params.type =2;
    const response =  await axios({
      method: 'POST',
      url: `${API_URL}get-account`,
      headers: { 'Content-Type': 'application/json' },
      data: param.params
    });
    return response
  } catch (e) {
    return [];
  }
};
